module.exports = __webpack_public_path__ + "img/pv_grid_power_on.e01a2555.png";